<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>OAuth2 Scopes</glxy-page-title>
    <glxy-page-actions>
      <a routerLink="./create">
        <button mat-raised-button color="primary">Create</button>
      </a>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper>
    <div class="scopes-table">
      <div class="scopes-table-header">
        <mat-form-field>
          <mat-label>Search ID/Name/Description</mat-label>
          <input matInput (keyup)="applyFilter($event)" />
        </mat-form-field>
      </div>

      <table class="oauth2-configurations-table" mat-table content [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
          <td mat-cell *matCellDef="let row">
            <a routerLink="./edit/{{ row.id }}">{{ row.id }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">{{ row.name }}</td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let row">{{ row.description }}</td>
        </ng-container>

        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
          <td mat-cell *matCellDef="let row">
            {{ row.created | date: 'short' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="updated">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated</th>
          <td mat-cell *matCellDef="let row">
            {{ row.updated | date: 'short' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" tabindex="-1"></tr>
      </table>
      <mat-paginator />
    </div>
  </glxy-page-wrapper>
</glxy-page>
